import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { resolvePhoto } from "@/lib/api";

export default function MatchOverlay({ me, withUser, onClose, onMessage }) {
  return (
    <AnimatePresence>
      <motion.div
        data-testid="match-overlay"
        initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
        transition={{ duration: 0.4 }}
        className="fixed inset-0 z-50 grain-bg flex flex-col items-center justify-center px-6"
      >
        <div className="text-center max-w-md">
          <motion.div initial={{ y: 20, opacity: 0 }} animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.1 }}
            className="text-xs uppercase tracking-[0.35em] text-[#913831]">
            A new chapter
          </motion.div>
          <motion.h2 initial={{ y: 20, opacity: 0 }} animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="font-serif text-5xl sm:text-6xl tracking-tight text-[#1A1818] mt-4 leading-tight">
            It&apos;s a <em className="text-[#913831]">connection.</em>
          </motion.h2>

          <div className="mt-10 flex items-center justify-center gap-4">
            <Portrait user={me} delay={0.35} rotate={-6} />
            <Portrait user={withUser} delay={0.5} rotate={6} />
          </div>

          <motion.p initial={{ y: 10, opacity: 0 }} animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.75 }}
            className="mt-8 text-[#737373]">
            You and {withUser.name} both said yes.
          </motion.p>

          <motion.div initial={{ y: 12, opacity: 0 }} animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.9 }}
            className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
            <button data-testid="match-message-btn" onClick={onMessage}
              className="bg-[#913831] hover:bg-[#7A2E28] text-white rounded-full px-7 py-3.5 font-medium">
              Write to {withUser.name}
            </button>
            <button data-testid="match-keep-btn" onClick={onClose}
              className="border border-[#E5DFD3] hover:bg-[#F0EBE1] text-[#1A1818] rounded-full px-7 py-3.5 font-medium">
              Keep browsing
            </button>
          </motion.div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
}

function Portrait({ user, delay, rotate }) {
  return (
    <motion.div
      initial={{ scale: 0.7, opacity: 0, rotate: rotate * 1.5 }}
      animate={{ scale: 1, opacity: 1, rotate }}
      transition={{ duration: 0.55, delay, type: "spring", stiffness: 90 }}
      className="bg-white p-2 pb-4 rounded-2xl shadow-[0_30px_60px_-25px_rgba(0,0,0,0.25)] border border-[#E5DFD3]"
    >
      <div className="w-32 h-40 sm:w-36 sm:h-44 rounded-xl overflow-hidden bg-[#F0EBE1]">
        {user?.photos?.[0] ? (
          <img src={resolvePhoto(user.photos[0])} alt="" className="w-full h-full object-cover" />
        ) : (
          <div className="w-full h-full flex items-center justify-center font-serif text-3xl text-[#737373]">
            {user?.name?.[0]}
          </div>
        )}
      </div>
      <div className="mt-2 text-center font-serif text-lg text-[#1A1818]">{user?.name}</div>
    </motion.div>
  );
}
